import { TraitTypeAspectEventHandler } from './TraitRegistryEventFromRegistry';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
export class TraitRegistryEventBasic extends TraitRegistryCategory {
    label = 'Basic';
    constructor(parent) {
        super(parent);
        super.init();
    }
    eventType = () => new TraitTypeSelect({
        /* label: 'Event Typ',
      init: 'click', */
        select: () => this.registry.eventRegistry.allLeafs.map((item) => [item.key]),
    });
    onSequenceEnd = () => new TraitTypeAspectEventHandler();
    onAspectMeasure = () => new TraitTypeAspectEventHandler();
}
